import { Stack, Skeleton } from "@mui/material";

export const LoyaltyMonthDropdownSkeleton = () => (
  <Stack>
    <Skeleton variant="text" width={56} sx={{ fontSize: "1rem", mb: 1.3 }} />
    <Skeleton
      variant="rounded"
      width="100%"
      sx={{ height: ({ spacing }) => spacing(10) }}
    />
  </Stack>
);
